// removed by extract-text-webpack-plugin
module.exports = {"compare_box_wrapper":"CompareBox--compare_box_wrapper--1DpV4","compare_box":"CompareBox--compare_box--qjs4g","compare_box_item":"CompareBox--compare_box_item--1NdsW","compare_box_title":"CompareBox--compare_box_title--160qe","compare_box_content":"CompareBox--compare_box_content--2YwbJ"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/CompareBox/CompareBox.css
// module id = 1014
// module chunks = 0